<script lang="ts">
  import {t} from './i18n'
  import {onMount} from 'svelte'
  import {user} from './stores/user'
  import {navigate} from 'svelte5-router'
  import {flash} from './stores/flash'
  import api from './api/api'

  export let token: string

  onMount(() => {
    if ($user) {
      navigate('/')
      flash.show(t.flash.reset_password.logged_in, 'error')
      return
    }
  })

  let newPassword = {
    password: '',
    password_confirmation: ''
  }

  let passwordConfirmationInput: HTMLInputElement

  const validatePassword = (): boolean => {
    if (newPassword.password === newPassword.password_confirmation) {
      passwordConfirmationInput.setCustomValidity('')
      return true
    } else {
      passwordConfirmationInput.setCustomValidity(t.errors.validation.password_matches)
      return false
    }
  }

  const submit = async (e: Event) => {
    e.preventDefault()
    if (!validatePassword()) {
      return
    }

    await api.put('/reset_password', {id: token, ...newPassword})
    navigate('/')
    flash.show(t.flash.reset_password.success)
  }
</script>

<div class="row">
  <div class="grid-section">
    <div class="heading with-filter inner-heading">
      <h2>{t.reset_password.title}</h2>
    </div>

    <div class="grid one">
      <div class="grid__item">
        <form onsubmit={submit}>
          <div class="line">
            <input type="password" required placeholder={t.reset_password.password}
                   minlength={6} maxlength={255}
                   bind:value={newPassword.password}/>
          </div>
          <div class="line">
            <input type="password" placeholder={t.reset_password.password_confirmation}
                   bind:value={newPassword.password_confirmation}
                   bind:this={passwordConfirmationInput}
                   oninput={() => passwordConfirmationInput.setCustomValidity('')}/>
          </div>
          <button type="submit" class="ui button black">
            {t.reset_password.submit}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
